import { useMagasinStore } from "@/store/magasin";
import { useDatalayerStore } from "@/store/datalayer";
import { usePanierStore } from "@/store/panier";
import apiDriveListe from "@/services/http/api-drive/client/listeDeCourse";
import dateUtils from "@/utils/date";
import cookieService from "~/services/storage/cookie.client";
import { useInteractionDoneTracking } from "@/mixins/tracking/interaction-done"

export const pageMonCompteMesListesDeCoursesDetailProps = () => ({
  id: {
    type: [String, Number],
    required: true
  },
  liste: {
    type: Object,
    required: false,
    default: null
  },
  meta: {
    type: Object,
    required: false,
    default: null
  },
  pageIsLoading: {
    type: Boolean,
    required: false,
    default: false
  }
})

export const pageMonCompteMesListesDeCoursesDetailEmits = () => ([
  "reload"
])

export const usePageMonCompteMesListesDeCoursesDetail = (props, context, supprimerProduitRef, supprimerRef, productListRef, renommerRef) => {

  const app = useNuxtApp()
  const router = useRouter()
  const magasinStore = useMagasinStore()
  const datalayerStore = useDatalayerStore()
  const panierStore = usePanierStore()

  const { trackEvent } = useInteractionDoneTracking();

  const listes = ref([])
  const isLoading = ref(false)
  const updateListeError = ref(null)
  const updateListeState = ref(null)
  const produitsToDelete = ref([])

  const { id: magasinId, isNational } = storeToRefs(magasinStore)

  const { setStoreLocatorContext } = datalayerStore;

  const { displayStoreLocator } = magasinStore;

  const { addListeDeCourseToPanier, addListeProduitsToPanier } = panierStore;

  const noProduct = computed(() => {
    if (props.liste) {
      return props.liste.attributes.nb_produits === 0 && props.liste.attributes.nb_produits_manquant === 0;
    }
    return true;
  })

  const dateLastUsageFormatted = computed(() => {
    if (props.liste) {
      if (props.liste.attributes.date_last_usage && props.liste.attributes.date_last_usage !== props.liste.attributes.date_creation) {
        return "Modifiée le " + dateUtils.formatDateTime(props.liste.attributes.date_last_usage);
      } else {
        return "Créée le " + dateUtils.formatDateTime(props.liste.attributes.date_creation);
      }
    }
  })

  const deleteProduits = (produits) => {
    produitsToDelete.value = produits.map(p => { return p.id });
    supprimerProduitRef.value.show();
  }
  const deleteListe = () => {
    supprimerRef.value.show();
  }

  const getListesDeCourse = async () => {
    isLoading.value = true;
    try {
      listes.value = await app.$apiDrive
        .use(apiDriveListe)
        .listeDeCourses({
          magasin_id: magasinId.value
        });
    } finally {
      isLoading.value = false;
    }
  }
  const confirmDeleteListe = async () => {
    isLoading.value = true;
    try {
      await app.$apiDrive.use(apiDriveListe).delete(props.id);
      supprimerRef.value.hide();
      router.replace("/mon-compte/mes-listes-de-courses");
    } finally {
      isLoading.value = false;
    }
  }
  const confirmDeleteProduits = async () => {
    isLoading.value = true;
    try {
      await app.$apiDrive.use(apiDriveListe).deleteItems(props.id, produitsToDelete.value);
      supprimerProduitRef.value.hide();
      productListRef.value.unselectAll();
      context.emit('reload');
    } finally {
      isLoading.value = false;
    }
  }
  const addToCartListe = async () => {
    if (isNational.value) {
      displayStoreLocator();
      return;
    }
    try {
      isLoading.value = true;
      trackEvent({
        actionGA: trackingCodes.ACTIONGA.cartAttachement,
        categoryGA: trackingCodes.SHOPPINGLIST,
        labelGA: ''
      });
      await addListeDeCourseToPanier(props.id);
    } finally {
      isLoading.value = false;
    }
  }
  const addToCartProduits = (produits) => {
    if (isNational.value) {
      displayStoreLocator();
      return;
    }
    try {
      isLoading.value = true;
      addListeProduitsToPanier(produits);
    } finally {
      isLoading.value = false;
    }
  }
  const renameListe = async (titre) => {
    updateListeState.value = "loading"
    try {
      await app.$apiDrive.use(apiDriveListe).update(props.liste.id, {
        titre
      });
      updateListeState.value = null;
      renommerRef.value.hide();
      context.emit('reload');
    } catch (e) {
      updateListeError.value = app.$apiDrive.getErrorData(e);
    } finally {
      updateListeState.value = null;
    }
  }
  const mounted = async () => {
    await getListesDeCourse();
    setStoreLocatorContext('liste des courses');
  }

  return {
    listes,
    isLoading,
    updateListeError,
    updateListeState,
    produitsToDelete,
    noProduct,
    dateLastUsageFormatted,
    deleteProduits,
    deleteListe,
    getListesDeCourse,
    confirmDeleteListe,
    confirmDeleteProduits,
    addToCartListe,
    addToCartProduits,
    renameListe,
    mounted
  }
}